import AcTransactionsOverviewAllTab from './all/all';
import AcTransactionsOverviewIncomingTab from './incoming/incoming';
import AcTransactionsOverviewOutgoingTab from './outgoing/outgoing';

export default {
  All: AcTransactionsOverviewAllTab,
  Incoming: AcTransactionsOverviewIncomingTab,
  Outgoing: AcTransactionsOverviewOutgoingTab,
};
